export const formatDateToYYYYMMDD = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

export const getStartAndEndDates = (start_date?: Date, end_date?: Date): { start_date: Date, end_date: Date } => {
    const today = new Date();
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(today.getMonth() - 1); // Subtract one month from today

    // If no start_date or end_date are provided, default to today and one month ago
    const actualStartDate = start_date || oneMonthAgo;
    const actualEndDate = end_date || today;

    return { start_date: actualStartDate, end_date: actualEndDate };
};
